var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeePot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428 175L480 32H88C39.399 32 0 71.399 0 120V200C0 213.255 10.745 224 24 224H24C37.255 224 48 213.255 48 200V120C48 97.909 65.909 80 88 80H113.5L148.25 175.5C96.875 215.25 64 276.125 64 344.625C64 396.125 82.625 429.375 113.625 462.375C124.5 473.625 139.5 480 155.125 480L420.875 480C436.406 480 451.452 473.812 462.114 462.519C493.195 429.597 512 396.2 512 344.625C512 276.875 480 215.125 428 175ZM411.5 80L382.375 160H193.625L164.5 80H411.5ZM114.125 320C121.25 273.75 148.25 234.125 186.25 208H392.125C429.375 234.125 455.125 274.25 461.875 320H114.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeePot);
export default __webpack_public_path__ + "static/media/coffee-pot.a6ec85a91caed40a20e1313fb4a741cd.svg";
export { ForwardRef as ReactComponent };